import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { HoustonPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How can TekRevol help me with software development in Houston?",
    answer: `<p>TekRevol is a custom software development company in Houston helping clients understand their business goals better and uncover strategies and action plans to digitize their ROI and customer engagement channels. We can help you create audience personas, wireframes, mockups, UI/UX designs, outline and project specifications, the tool's entire backend and front end, and server-side architecture.</p>`,
  },
  {
    question: " How long do you take to deliver a software product?",
    answer: `<p>It depends on the project’s complexity, and efforts required to complete the project. The average time to develop a feature-rich mobile software with all the design and functionalities is around 6 – 8 months. However, the timeline can be exceeded further based on the scale of your project.</p>`,
  },
  {
    question: " Why should we hire you for software development in Houston?",
    answer: `<p>TekRevol is a reliable software development company in Houston, offering a wide range of services to the clients worldwide. From software design and development to deployment, and utilization of recent technologies – we can do it all. You can always hire our team of professional software developers in Houston, and convert your dreams into reality.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{HoustonPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
